var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var ALL_LANGUAGES = ['en', 'de', 'it', 'es', 'fr', 'ja', 'zh', 'ru'];
export var useSupportedLanguages = function () {
    return ALL_LANGUAGES;
};
/**
 * Every language the organization operates in.
 *
 * The API maintains `allLanguages` (`primaryLanguage` + `supportedLanguages`, primary first and
 * de-duplicated) on every organization save, so this is just a read. The local merge below is a
 * fallback for the deploy window before the API ships that field - it can be dropped once the
 * backend backfill has run everywhere.
 */
export var getOrganizationLanguages = function (organization) {
    var _a, _b;
    if ((_a = organization === null || organization === void 0 ? void 0 : organization.allLanguages) === null || _a === void 0 ? void 0 : _a.length) {
        return organization.allLanguages;
    }
    var languages = __spreadArray([organization === null || organization === void 0 ? void 0 : organization.primaryLanguage], ((_b = organization === null || organization === void 0 ? void 0 : organization.supportedLanguages) !== null && _b !== void 0 ? _b : []), true).filter(function (lang) { return !!lang; })
        .filter(function (lang, index, all) { return all.indexOf(lang) === index; });
    return languages.length ? languages : ALL_LANGUAGES;
};
